import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import I18n from '@utils/i18n';

// `text` is tenant-authored rich text. The ERB table this replaces rendered it with `.html_safe`,
// so it is rendered as HTML here too -- narrowing it to plain text would change what admins see.
// Sanitize on render (DOMPurify) so event-handler markup cannot execute in another staff session.
function TextCell({ item }) {
  return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.text || '') }} />;
}

TextCell.propTypes = { item: PropTypes.shape({ text: PropTypes.string }).isRequired };

function EditCell({ item }) {
  return <a href={item.editPath}>{I18n.t('generic.edit')}</a>;
}

EditCell.propTypes = { item: PropTypes.shape({ editPath: PropTypes.string }).isRequired };

function DefaultForTechCell({ item }) {
  return <span>{I18n.t(item.defaultForTech ? 'generic.yes' : 'generic.no')}</span>;
}

DefaultForTechCell.propTypes = { item: PropTypes.shape({ defaultForTech: PropTypes.bool }).isRequired };

const getColumns = (namespace) => [
  {
    label: I18n.t(`${namespace}.table.name`),
    dataKey: 'name'
  },
  {
    label: I18n.t(`${namespace}.table.text`),
    dataKey: 'text',
    width: '60%',
    renderer: TextCell
  },
  {
    label: I18n.t(`${namespace}.table.default_for_tech`),
    dataKey: 'defaultForTech',
    renderer: DefaultForTechCell
  },
  {
    label: '',
    dataKey: 'actions',
    renderer: EditCell
  }
];

export default getColumns;
